import businessInsider from '../../../../assets/homepage/featured_in/business-inside.svg';
import cityam from '../../../../assets/homepage/featured_in/city-a-m.svg';
import DW from '../../../../assets/homepage/featured_in/deutsche-welle.svg';
import FI from '../../../../assets/homepage/featured_in/fi.svg';
import forbes from '../../../../assets/homepage/featured_in/forbes.svg';
import skyNews from '../../../../assets/homepage/featured_in/sky-news.svg';

export default [
  {
    id: 1,
    logo: forbes,
    width: 87,
    height: 23,
  },
  {
    id: 2,
    logo: skyNews,
    width: 136,
    height: 28,
  },
  {
    id: 3,
    logo: cityam,
    width: 110,
    height: 25,
  },
  {
    id: 4,
    logo: DW,
    width: 63,
    height: 36,
  },
  {
    id: 5,
    logo: FI,
    width: 36,
    height: 36,
  },
  {
    id: 6,
    logo: businessInsider,
    width: 94,
    height: 30,
  },
];
